import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule, ServiceResponseModule } from '@sdbn/common';
import { CleanTransportComponent } from './clean-transport/component/clean-transport.component';



@NgModule({
  declarations: [
    CleanTransportComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CommonLayoutModule,
    CommonUIModule,
    CommonTranslationModule,
    ServiceResponseModule,
    MatFormFieldModule,
    MatRadioModule,
    MatInputModule
  ]
})
export class CleanTransportModule { }
